export const HTTP_STATUS_CODE_FIRST_ACCESS = 418;

export const isAuthorizedRequest = (response: { status: number }) => {
  return response && response.status !== 401;
};

export const isFirstAccess = (response: { status: number }) => {
  return response && response.status === HTTP_STATUS_CODE_FIRST_ACCESS;
};

export const haveNoAccess = (response: { status: number }) => {
  return response && response.status === 403;
};

export const ErroDadosNaoEncontradosParaRelatorio = (status: number) => {
  return status === 417;
};

export const ErroVolumeDeDadosRelatorio = (status: number) => {
  const errorStatus = [500, 501, 502];
  return errorStatus.includes(status);
};